import { useDispatch, useSelector } from 'react-redux';

import {
  setNoteDisplayDialog,
  setSelectedCnRow,
  setShownNote,
  toggleContactNoteDrawer,
} from 'reducers/contactNoteListReducer';
import { GlobalState } from 'reducers/stateTypes';
import ContactNote from 'types/ContactNote';
import { DisplayDialogs } from 'views/ContactNotes/ContactNotesContainer';

// Opens a note in the ContactNotes grid's detail drawer, same as clicking its row would.
// Shared so both the grid's row click and other UI (e.g. a toast action button) can trigger it.
export const useOpenContactNote = () => {
  const dispatch = useDispatch();
  const selectedRow = useSelector((state: GlobalState) => state.contactNoteList.selectedRow);
  const drawerOpen = useSelector((state: GlobalState) => state.contactNoteList.drawerOpen);

  return (note: ContactNote) => {
    dispatch(setShownNote(note));
    dispatch(setSelectedCnRow(selectedRow === note.id ? undefined : note.id));
    dispatch(setNoteDisplayDialog(DisplayDialogs.DEFAULT_NOTE_VIEW));
    dispatch(toggleContactNoteDrawer(drawerOpen ? selectedRow !== note.id : true));
  };
};

export default useOpenContactNote;
